import { Component, OnInit, Inject } from '@angular/core';
import { InputDataComponent } from '../input-data/input-data.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DBService } from '../../../services/db.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Activity, ActivityStatus } from '../../../model/activity';
import { Company } from '../../../model/company';
import { Bidding, BiddingStatus, BiddingUpdateAction } from '../../../model/bidding';

import { HttpClient } from '@angular/common/http';
import { Employee } from '../../../model/employee';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-new-bidding',
  templateUrl: './new-bidding.component.html',
  styleUrls: ['./new-bidding.component.css'],
  providers: [DBService, AuthenticationService]
})
export class NewBiddingComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  inputData: string;

  bidding: Bidding = new Bidding();

  companies: Company[];
  employees: Employee[];

  loading: boolean;

  uid: string;

  title: string;

  selectedFile: File;

  products: string[];

  NovaLicitacao = 'https://us-central1-i-ganhei.cloudfunctions.net/NovaLicitacao';

  constructor(
    public dialogRef: MatDialogRef<InputDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dbService: DBService, private authService: AuthenticationService, private http: HttpClient) {
      this.loading = true;

      $('#overlay').show();
      this.updateLabels();

      this.uid = data.uid;
      if (this.uid) {
        this.title = 'Editar Licitação';
      } else {
        this.title = 'Nova Licitação';
      }

      this.initData();
  }

  private initData() {
    
    this.dbService.listWithUIDs<Employee>('employees')
      .then(employees => {
        this.employees = employees;
      });

    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.companies = companies;

        if (this.uid) {
          this.setupEdit();
        } else {
          this.setupNew();
        }
      });
  }

  private setupNew() {
    this.authService.getCurrentUser().subscribe(currentUser => this.bidding.sentUserUID = currentUser.uid);

    this.loading = false;
  }

  private setupEdit() {
    this.dbService.getObject<Bidding>(`biddings/${this.uid}`)
      .then(bidding => {
        this.bidding = bidding;
        this.products = this.companies.filter(c => c.uid === this.bidding.companyUID)[0].products;
        this.loading = false;
      }).catch(error => console.log(error));
  }

  hideOverlay(): void {
    $('#overlay').hide();
  }

  ngOnInit() {
  }

  onChange(event) {
    if (this.bidding == null || this.bidding.biddingDateString == null) {
      return;
    }

    const dateParts = this.bidding.biddingDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.bidding.biddingDate;
    } else {
      this.bidding.biddingDate = date.getTime();
    }
  }

  onChangeLimit(event) {
    if (this.bidding == null || this.bidding.limitDateString == null) {
      return;
    }

    const dateParts = this.bidding.limitDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.bidding.limitDate;
    } else {
      this.bidding.limitDate = date.getTime();
    }
  }

  save() {
    if (this.uid) {
      this.edit();
    } else {
      this.create();
    }
  }

  private edit() {
    this.loading = true;

    if (this.selectedFile) {
      this.uploadAndEdit();
    } else {
      this.confirmEdit();
    }
  }

  private uploadAndEdit() {
    this.dbService.uploadFile('biddings', this.selectedFile)
      .then(url => {
        this.bidding.noticeURL = url;
        this.confirmEdit();
    }).catch(error => console.log(error));
  }

  private confirmEdit() {
    const updatingObj =  {
      purchasingOrgan: this.bidding.purchasingOrgan,
      biddingDate: this.bidding.biddingDate,
      biddingDateString: this.bidding.biddingDateString,
      product: this.bidding.product,
      companyUID: this.bidding.companyUID,
      noticeURL: this.bidding.noticeURL,
      observations: this.bidding.observations,
      updatingDate: new Date().getTime(),
      updatingAction: BiddingUpdateAction.UPDATED
    };

    this.setFieldIfItIsNotNull(updatingObj, 'edital');
    this.setFieldIfItIsNotNull(updatingObj, 'limitDate');
    this.setFieldIfItIsNotNull(updatingObj, 'limitDateString');
    this.setFieldIfItIsNotNull(updatingObj, 'productDateString');
    this.setFieldIfItIsNotNull(updatingObj, 'biddingType');
    this.setFieldIfItIsNotNull(updatingObj, 'tipoJulgamento');
    this.setFieldIfItIsNotNull(updatingObj, 'prazoPagamento');
    this.setFieldIfItIsNotNull(updatingObj, 'localEntrega');
    this.setFieldIfItIsNotNull(updatingObj, 'amostra');
    this.setFieldIfItIsNotNull(updatingObj, 'laudoTecnico');
    this.setFieldIfItIsNotNull(updatingObj, 'visitaTecnica');
    this.setFieldIfItIsNotNull(updatingObj, 'descricaoVisitaTecnica');
    this.setFieldIfItIsNotNull(updatingObj, 'garantiaContratual');
    this.setFieldIfItIsNotNull(updatingObj, 'descricaoServicos');
    this.setFieldIfItIsNotNull(updatingObj, 'documentacaoTecnica');
    this.setFieldIfItIsNotNull(updatingObj, 'descricaoDocumentacaoTecnica');

    this.dbService.update(`biddings/${this.uid}`, updatingObj)
      .then(result => {
        Materialize.toast('Licitação atualizada com sucesso', 2000);
        this.hideOverlay();

        this.dialogRef.close(true);
      }).catch(error => console.log(error));
  }

  private setFieldIfItIsNotNull(obj, property) {
    if (this.bidding[property] != null && this.bidding[property] != '') {
      obj[property] = this.bidding[property];
    }
  }

  sendNotifyEmail() {
    
    var emailsList = this.employees.filter(c => c.companyUID === this.bidding.companyUID);
    var toEmails = [];

    for(let i = 0; i < emailsList.length; i++) {
      toEmails.push({"email": emailsList[i].email});
    }

    const dataNotify = {
      toEmailNovaLicitacao: toEmails,
      toNameNovaLicitacao: this.companies.filter(c => c.uid === this.bidding.companyUID)[0].name,
      editalNovaLicitacao: this.bidding.edital,
      dateNovaLicitacao: this.bidding.limitDateString
    }

    this.http.post(this.NovaLicitacao, dataNotify).subscribe();

  }

  private create() {
    this.loading = true;

    this.bidding.creationDate = Date.now();
    this.bidding.status = BiddingStatus.NEW;
    this.bidding.updatingDate = Date.now();
    this.bidding.updatingAction = BiddingUpdateAction.CREATED;

    this.dbService.uploadFile('biddings', this.selectedFile)
      .then(url => {
        this.bidding.noticeURL = url;

        this.dbService.insertInList<Bidding>('/biddings', this.bidding)
        .then(result => {
          Materialize.toast('Licitação cadastrada com sucesso', 2000);
          this.hideOverlay();

          this.dialogRef.close(true);
        }).catch(error => console.log(error));
    });

    this.sendNotifyEmail();

  }

  private updateLabels() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }

  detectFiles(event) {
    this.selectedFile = event.target.files[0];
  }

  loadProducts() {
    this.products = this.companies.filter(c => c.uid === this.bidding.companyUID)[0].products;
    this.bidding.product = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/partials/new-bidding/new-bidding.component.ts